import { Card } from '../Cards/index';
import { Grid, GridItem, GridRow } from '../Grid';
import { Slider } from '../SliderVanilla';
import {
  Container,
  IntroContent,
  SubHeading,
  Heading,
  Description,
  TextContainer,
  CardsContainer,
  CarouselCard,
} from './styles';

export interface ItipsAndTricksProps {
  super?: string;
  title?: string;
  description?: string;
  titleTag?: string;
}

export const TipsAndTricks = ({
  introText,
  cardsData,
  recipes,
  difficultyCopy,
  trackingEvent,
}: {
  introText: ItipsAndTricksProps;
  cardsData: any;
  recipes: any;
  difficultyCopy: any;
  trackingEvent?: (data?: any, position?: number) => void;
}) => {
  const totalCards = cardsData.map((item: any, index: number) => (
    <Card
      // eslint-disable-next-line react/no-array-index-key
      key={item.id ?? `total-card-${index}`}
      data={item}
      showInfo
      height="500px"
      video={item.video}
      copyDictionary={difficultyCopy}
      link={item.link}
      trackingEvent={trackingEvent}
      position={index + 1}
    />
  ));

  const totalCardsCarousel = cardsData.map((item: any, index: number) => (
    <CarouselCard key={item.id ?? `totalCardsCarousel-${index}`}>
      <Card
        // eslint-disable-next-line react/no-array-index-key
        key={`total-card-${index}`}
        data={item}
        showInfo
        height="500px"
        video={item.video}
        copyDictionary={difficultyCopy}
        link={item.link}
        trackingEvent={trackingEvent}
        position={index + 1}
      />
    </CarouselCard>
  ));

  const backgroundMobile = recipes?.[0].recipelifestyle?.[0]?.asset?.[1].url;
  const backgroundDesktop = recipes?.[0].recipelifestyle?.[0]?.asset?.[0].url;

  const IntroTextDisplay = (
    <Grid>
      <GridRow columns={16}>
        <GridItem colStart={3} colSpan={12}>
          <IntroContent>
            <SubHeading tag="p" type="lead">
              {introText.super}
            </SubHeading>
            <Heading tag="h2" type="md">
              {introText.title}
            </Heading>
            <Description tag="p" type="lg">
              {introText.description}
            </Description>
          </IntroContent>
        </GridItem>
      </GridRow>
    </Grid>
  );

  const CardsDisplay = (
    <Grid>
      <div className="hidden lg:block">
        <>
          {totalCards.length === 1 && (
            <GridRow columns={16}>
              <GridItem colSpan={16}>{totalCards[0]}</GridItem>
            </GridRow>
          )}
          {totalCards.length === 2 && (
            <GridRow columns={16}>
              <GridItem colSpan={8}>{totalCards[0]}</GridItem>
              <GridItem colSpan={8}>{totalCards[1]}</GridItem>
            </GridRow>
          )}
          {totalCards.length >= 3 && (
            <GridRow columns={12} className="hidden lg:grid">
              {totalCards?.map((item: any) => (
                <GridItem key={item.id} colSpan={4}>
                  {item}
                </GridItem>
              ))}
            </GridRow>
          )}
        </>
      </div>
      <div className="lg:hidden">
        <Slider>{totalCardsCarousel}</Slider>
      </div>
    </Grid>
  );

  return (
    <Container data-print="hide">
      <TextContainer backgroundMobile={backgroundMobile} backgroundDesktop={backgroundDesktop}>
        {IntroTextDisplay}
      </TextContainer>
      <CardsContainer>{CardsDisplay}</CardsContainer>
    </Container>
  );
};
